var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{staticClass:"main-container-content",class:{
    // hasTagsView:needTagsView,
    'main-container':false}},[_c('div',{class:{'fixed-header':_vm.fixedHeader}},[_c('headbar')],1),_c('div',{staticClass:"content-container"},[_c('leftMain'),_c('app-main')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }